import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { MonthSelector } from 'components/Shared/MonthSelector';

export interface PageHeaderTabsProps {
  currentTab: number;
  tabs: string[];
  setTab: (tabIndex: number) => void;
}

export interface PageHeaderButtonConfig {
  title: string;
  onClick: () => void;
}

export interface PageHeaderButtonsProps {
  buttons: PageHeaderButtonConfig[];
}

export interface PageHeaderProps {
  title: string;
  tabs?: PageHeaderTabsProps;
  buttons?: PageHeaderButtonsProps;
  monthSelector?: boolean;
  rightItemsBefore?: React.ReactNode;
}

const PageHeaderTabs = ({ currentTab, setTab, tabs }: PageHeaderTabsProps) => {
  return (
    <Tabs
      value={currentTab}
      onChange={(_, tabIndex: number) => setTab(tabIndex)}
      sx={{ ml: '2rem', flexGrow: 1 }}
    >
      {tabs.map(tab => (
        <Tab key={tab} label={tab} />
      ))}
    </Tabs>
  );
};

const PageHeaderButtons = ({ buttons }: PageHeaderButtonsProps) => {
  return (
    <Box sx={{ '& > *': { ml: 1 } }}>
      {buttons.map(button => (
        <Button
          key={button.title}
          variant="outlined"
          size="small"
          onClick={button.onClick}
        >
          {button.title}
        </Button>
      ))}
    </Box>
  );
};

const PageHeader = ({
  tabs,
  title,
  buttons,
  monthSelector = false,
  rightItemsBefore
}: PageHeaderProps) => {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        position: 'relative',
        marginBottom: '1em',
        display: {
          xs: 'none',
          md: 'flex'
        },
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Box
        sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}
      >
        <Typography
          variant="h6"
          sx={{ lineHeight: '3rem', flexGrow: tabs ? undefined : 1 }}
        >
          {title}
        </Typography>
        {tabs && <PageHeaderTabs {...tabs} />}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
      >
        {rightItemsBefore && <Box sx={{ mr: 2 }}>{rightItemsBefore}</Box>}
        {monthSelector && <MonthSelector />}
        {buttons && <PageHeaderButtons {...buttons} />}
      </Box>
    </Box>
  );
};

export default PageHeader;
